import React from 'react'
import { AccountDetails, CdFrequency } from '../../../types'
import { NavLinkDL } from './NavLinkDl'
import { CD_FREQUENCY } from '../../../utils/constants'

export const PayMyInterestDl: React.FC<{
  account: AccountDetails
  accountClosed: boolean
}> = ({ account, accountClosed }) => {
  const isRetirementAccount = account.retirementAccountIndicator
  return account.cdInstructionDetails ? (
    <NavLinkDL
      title="Pay My Interest:"
      definition={
        CD_FREQUENCY[
          account.cdInstructionDetails.currentTermInterestOptions
            .postingFrequency as CdFrequency
        ]
      }
      to={`/bank/manage-cds/interest-disbursement?id=${account.accountIndex}`}
      disabled={isRetirementAccount || accountClosed}
    />
  ) : null
}
